import dynamic from 'next/dynamic'
import Head from 'next/head'
import Header from '../../../components/Header';
import CTA from '../../../components/CTA';
import YoastSEO from '../../../components/YoastSEO';
import CategoryPosts from '../../../components/CategoryPosts';
import Script from 'next/script'
import { RouteChangeListener } from '../../../components/OptinMonsterEmbed';

import { client } from '../../../lib/apollo';
import { GET_HEADER_OPTIONS, GET_FOOTER_OPTIONS, GET_BLOG_OPTIONS, 
  GET_CATEGORIES, GET_CATEGORY_POSTS } from '../../../queries/queries';


const DynamicFooter = dynamic(() => import('../../../components/Footer'))

export default function NewsPage({pageData}) {
  
const cta = pageData?.footerData?.data?.siteOptions?.siteOptions?.cta[0];
const headerData = pageData?.headerData;
const footerData = pageData?.footerData;
const categories = pageData?.categoryList.data.categories.nodes;
const newsList = pageData?.newsList;
const subtitle = pageData.footerData.data.siteOptions.siteOptions.headerContent;
const slug = pageData.slug;

let seoData = {
  title: 'Natural Lands | News | ' + slug
}

  return (
    <div className='wrap'>
      <YoastSEO
          page={seoData}
          MetaRenderElement={Head}
          meta={<>
            <meta name="MobileOptimized" content="width" />
            <meta name="HandheldFriendly" content="True"/>
            <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0" />
            <title>Natural Lands</title>
            <link rel="icon" href="/assets/favicon/favicon.ico"></link>
          </>}
        ></YoastSEO>
      <Header header={headerData}></Header>
      <main>
        <div id="content" role="main">
            <div id="news-header-container" className='container-fluid'>
                <div>
                  <div>
                      <div className='container'>
                        <h1>news</h1>
                        {
                          subtitle && (
                            <p className='subtitle'>{subtitle}</p>
                          )
                        }
                      </div>
                  </div>
                </div>
            </div>
            <div id="news-filter-container" className='container'>
                <div>
                    <div>
                        <div>
                            <a href="/news/" className='custom-link'>
                                all
                            </a>
                        </div>
                        {
                            categories && categories.length>0 && categories.map((item, index) => (  
                              <div>
                                {
                                    item.slug === slug && (
                                        <a key={index} href={`${item.uri}`} className='custom-link active'>
                                            {item.name}
                                        </a>
                                    )
                                }
                                {
                                    item.slug !== slug && (
                                        <a key={index} href={`${item.uri}`} className='custom-link'>
                                            {item.name}
                                        </a>
                                    )
                                }
                              </div>
                            ))
                        }
                    </div>
                </div>
            </div>
            <div id="news-list-wrapper" className='container-fluid'>
                <CategoryPosts
                  newsList={newsList}
                ></CategoryPosts>
            </div>
            <CTA
              cta={cta}
            ></CTA>
        </div>
        <Script defer={true}>
            {`(function(d,u,ac){var s=d.createElement('script');s.type='text/javascript';s.src='https://a.omappapi.com/app/js/api.min.js';s.async=true;s.dataset.user=u;s.dataset.account=ac;d.getElementsByTagName('head')[0].appendChild(s);})(document,32897,23154);
    <!-- / OptinMonster -->`}
            </Script>
            <RouteChangeListener/>
      </main>
      <DynamicFooter footer={footerData}></DynamicFooter>
    </div>
  )
}

export async function getStaticProps({params}){
  const headerData = await client.query({
    query: GET_HEADER_OPTIONS
});

  const footerData = await client.query({
    query: GET_FOOTER_OPTIONS
  });

  const categoryList = await client.query({
      query: GET_CATEGORIES
  });

  const newsList = await client.query({
      query: GET_CATEGORY_POSTS,
      variables: {
        first: 8,
        last: null,
        after: null,
        before: null,
        category: params?.uri
      }
  });

  return {
    props: {
      pageData: {
        footerData: footerData,
        categoryList: categoryList,
        newsList: newsList,
        headerData: headerData,
        slug: params.uri
      }
    },
    revalidate: 45,
  }
}

export async function getStaticPaths(){
    const paths = []
    return {
        paths,
        fallback: 'blocking'
    }
  }